import { call, put, takeLatest } from 'redux-saga/effects';
import { getFileSize } from '../../../../utils/format';
import { load3NDFLDraft } from '../../services/API/3ndfl';

import {
  getYears,
  save3NDFLXmlDraft,
  submitDeclaration,
  validateXML,
} from '../../services/API/3ndflXml';

import { unwrapAttributes } from '../../utils/attachments';
import {
  actionTypes,
  getDeclaraionDraftFailure,
  getDeclaraionDraftSuccess,
  getYearsFailure,
  getYearsSuccess,
  saveDraftFailure,
  saveDraftSuccess,
  submitDeclarationFailure,
  submitDeclarationSuccess,
  validateXMLFailure,
  validateXMLSuccess,
} from './actions';

const DECLARATION_DESCRIPTION = 'Декларация 3-НДФЛ';

//--------------- Save Draft ---------------//

function clearDraft(draft) {
  delete draft['declaration'];
  return draft;
}

function* saveDraft(action) {
  try {
    const clearedDraft = clearDraft(action.payload);
    const response = yield call(save3NDFLXmlDraft, clearedDraft);

    yield put(
      response.isOk
        ? saveDraftSuccess({ ...response.data, ...action.payload })
        : saveDraftFailure(response.error),
    );
  } catch (error) {
    yield put(saveDraftFailure(error));
  }
}

function* ndfl3XmlSaga() {
  yield takeLatest(actionTypes.SAVE_DRAFT, saveDraft);
}

//--------------- Years ---------------//

function processYears(data) {
  // Sort years
  data.sort(function (a, b) {
    return a.uiText - b.uiText;
  });

  return data.map((yearItem) => {
    yearItem.label = yearItem.uiText;
    yearItem.value = yearItem.formatVersion;

    return yearItem;
  });
}

function* getAvailableYears() {
  try {
    const response = yield call(getYears);

    if (response.isOk) {
      const years = processYears(response.data);
      yield put(getYearsSuccess(years));
    } else {
      yield put(getYearsFailure(response.error));
    }
  } catch (error) {
    yield put(getYearsFailure(error));
  }
}

function* ndfl3XMLYearsSaga() {
  yield takeLatest(actionTypes.GET_YEARS, getAvailableYears);
}

//--------------- Validate ---------------//

function* validate() {
  try {
    const response = yield call(validateXML);

    yield put(
      response.isOk ? validateXMLSuccess(response.data) : validateXMLFailure(response.error),
    );
  } catch (error) {
    yield put(validateXMLFailure(error));
  }
}

function* ndfl3XMLValidateSaga() {
  yield takeLatest(actionTypes.VALIDATE_XML, validate);
}

//--------------- Submit ---------------//

function* submit(action) {
  try {
    const response = yield call(submitDeclaration, action.payload);
    yield put(
      response.isOk
        ? submitDeclarationSuccess(response.data)
        : submitDeclarationFailure(response.error),
    );
  } catch (error) {
    yield put(submitDeclarationFailure(error));
  }
}

function* ndfl3XMLSubmitSaga() {
  yield takeLatest(actionTypes.SUBMIT_DECLARATION, submit);
}

//--------------- Get Draft ---------------//

function processDraft(draft) {
  // Process Declaration
  if (draft.payload.externalXmlFileId) {
    const sizeObject = getFileSize(draft.payload.externalXmlFileSize);

    draft.declaration = {
      isLocked: true,
      description: DECLARATION_DESCRIPTION,
      size: draft.payload.externalXmlFileSize,
      fileName: `${draft.payload.externalXmlFileId}.xml`,
      fileLink: draft.payload.externalXmlFileLink,
      sizeToDisplay: `${sizeObject.size}${sizeObject.units}`,
    };
  }
  // Process attaches
  if (draft.attaches) {
    draft.attaches = unwrapAttributes(draft.attaches);

    // Add human-readable size
    draft.attaches.forEach((file) => {
      const sizeObject = getFileSize(file.size);
      file.sizeToDisplay = `${sizeObject.size}${sizeObject.units}`;
    });
  }

  return draft;
}

function* getDraft(action) {
  try {
    const response = yield call(load3NDFLDraft, action.payload);

    if (response.isOk) {
      const processedDraft = processDraft(response.data);
      yield put(getDeclaraionDraftSuccess(processedDraft));
    } else {
      yield put(getDeclaraionDraftFailure(response.error));
    }
  } catch (error) {
    yield put(getDeclaraionDraftFailure(error));
  }
}

function* ndfl3XMLGetDraftSaga() {
  yield takeLatest(actionTypes.GET_DRAFT, getDraft);
}

export {
  ndfl3XmlSaga,
  ndfl3XMLYearsSaga,
  ndfl3XMLValidateSaga,
  ndfl3XMLSubmitSaga,
  ndfl3XMLGetDraftSaga,
};
